import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import cart from '@/store/modules/cart.module';
import odds from '@/store/modules/odds.module';
import rules from '@/store/modules/rules.module';
import settings from '@/store/modules/settings.module';
import socket from '@/store/modules/socket.module';
import tree from '@/store/modules/tree.module';
import user from '@/store/modules/user.module';
import sport from '@/store/modules/sport.module';
import result from '@/store/modules/result.module';
import marketview from '@/store/modules/marketview.module';
import treeV2 from '@/store/modules/treeV2.module';
import uiConfig from '@/store/modules/uiConfig.module';
import IllinoisSport from '@/store/illinois/sport.module';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'sport-rev-iframe',
      paths: [
        'cart.bet.odds',
        'cart.odds_variation',
        'cart.odds_sources',
        'cart.created_at',
        'cart.bet.type',
        'cart.bet._multiple_detail',
        'cart.bet._system_detail',
        'cart.bet._integral_detail',
        'cart.bet._integral_detail',
        'cart.combinableMarkets'
      ]
    })
  ],
  modules: {
    cart,
    odds,
    rules,
    settings,
    socket,
    tree,
    user,
    sport,
    result,
    marketview,
    treeV2,
    uiConfig,
    IllinoisSport
  }
});
